import { Icon } from '@fox/atoms';
import { useTheme } from 'styled-components';

interface StarRatingProps {
	rating: number;
	customColor?: string;
	fontSize?: string;
	fontWeight?: string | number;
}

export function StarRating({ rating, customColor, fontSize = '1rem', fontWeight = 'bold' }: StarRatingProps) {
	const theme = useTheme();

	return (
		<span
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				flexShrink: 0,
				lineHeight: 1,
				verticalAlign: 'middle'
			}}
		>
			<Icon
				iconName="Star"
				customColor={customColor || theme.colors.font}
				sx={{
					fontSize,
					marginRight: '0.25rem',
					verticalAlign: 'middle',
					lineHeight: 1
				}}
			/>
			<span
				style={{
					fontWeight,
					color: customColor || theme.colors.font,
					lineHeight: 1,
					verticalAlign: 'middle',
					fontSize
				}}
			>
				{rating.toFixed(1)}
			</span>
		</span>
	);
}
